import { CircularProgress, Stack, Typography } from '@mui/material';
import { Image } from 'app/components';
import React from 'react';
const Loader = () => {
    return (React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: (theme) => ({
            height: '100vh',
            padding: theme.spacing(0),
            color: theme.palette.primary.main,
            img: {
                display: 'none',
                position: 'absolute',
                width: '100%',
                height: '100%',
                objectFit: 'cover',
            },
            h6: {
                zIndex: '1',
                display: 'none',
                color: theme.palette.common.white,
                fontSize: '14px',
                marginTop: theme.spacing(2),
            },
        }) },
        React.createElement(Image, { name: 'authentication-layout.jpg', alt: 'authentication-layout' }),
        React.createElement(CircularProgress, { size: 24, color: 'inherit' }),
        React.createElement(Typography, { variant: 'h6' }, "\u041F\u043E\u0434\u043E\u0436\u0434\u0438\u0442\u0435, \u0438\u0434\u0451\u0442 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u043E\u0432...")));
};
export default Loader;
